import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-items-center container d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "d-flex justify-content-around m-3" }, "¿Por qué nosotros?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex justify-content-around" }, " \"Creer que por ser nativo puedes dar clase es como pensar que puedes ser cocinero porque comes cada día\" ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Profesores")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Abordamos con cuidado el tema de la elección de profesores para nuestro centro, por lo que nuestros profesores no son solo hablantes nativos, sino especialistas certificados en el campo de la enseñanza del español como lengua extranjera.")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Castellano")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Nuestro principal objetivo es preservar la pureza de la lengua que se habla en la propia España, por ello todos nuestros profesores vinieron a Rusia para enseñarte la lengua castellana de referencia.")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Grupos pequeños")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("No abrimos grupos grandes, por lo que los profesores tienen la oportunidad de prestar atención a cada uno de los alumnos.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_header = _resolveComponent("b-card-header")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_card_group = _resolveComponent("b-card-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "slide-fade-header",
      appear: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide-fade-header",
      appear: ""
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_b_card_group, null, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "slide-fade",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card, {
              "border-variant": "light",
              class: "m-4 porque-nosotros-card",
              style: {"min-width":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_card_header, {
                  class: "text-center",
                  "header-class": "porque-nosotros-card-header",
                  "border-variant": "white",
                  "header-bg-variant": "transparent"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "slide-fade-right",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_card, {
              "border-variant": "light",
              class: "m-4 porque-nosotros-card",
              style: {"min-width":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_card_header, {
                  class: "text-center",
                  "header-class": "porque-nosotros-card-header",
                  "border-variant": "light",
                  "header-bg-variant": "transparent"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide-fade-header",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_card, {
              "border-variant": "light",
              class: "m-4 porque-nosotros-card porque-nosotros-card--groups",
              style: {"min-width":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_card_header, {
                  class: "text-center",
                  "header-class": "porque-nosotros-card-header",
                  "border-variant": "light",
                  "header-bg-variant": "transparent"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}